// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"59688":"9d2759f2a67b6905","84248":"03b6159bf7a8d49b"}[chunkId] + ".css";
};